export default __webpack_public_path__ + "static/web-dark-48dae56bb734a74642e538b001cf0978.svg";